import { action, makeObservable, observable } from "mobx"

class SubmissionStateStore {
  @observable accessor isSubmitting: boolean = false

  constructor() {
    makeObservable(this)
  }

  @action
  setSubmitting(isSubmitting: boolean): void {
    this.isSubmitting = isSubmitting ?? false
  }
}

export const submissionStateStore = new SubmissionStateStore()
